import { gql } from '@apollo/client';

export const FAVORITE_FIELDS_QUERY = gql`
  query FavoriteFieldsQueryOperation {
    favoriteFields(limit: 5000) {
      objects {
        id
        fieldName
        fieldType
        applyToAllObjectTypes
        associatedObjectTypes
      }
    }
  }
`;
